import { combineReducers } from 'redux'

import * as h2Api from '../../h2Api'
import { SP_RESULTS } from '../../actions/assessments/skillsProfiler'

export default combineReducers({
  results: h2Api.restReducer(SP_RESULTS)
})
